import { ArtistPortalAuthKind } from 'fym-shared/src/smartlinks/artistPortals';
import { config } from '../../../config/config';

/**
 * The native connect of one source: `<scheme>://catalog/connect/<integrationType>`, for example
 * `music24://catalog/connect/ditto`.
 *
 * The Catalog web page inside the iOS and Android app cannot run every sign-in: Ditto logs in on
 * its own page in a web view of the app, Spotify for Artists needs the app to read its redirect,
 * and YouTube (Google) refuses an embedded web view and needs the app's return scheme. The web
 * view hands a link in the app's own scheme to the app's deep-link router (`AppDeepLink.kt`,
 * `DeepLinks.swift`), which opens Catalog with the native connections sheet on that source
 * (design your-intelligence h4). Both apps take the `integrationType` as the link name.
 *
 * The scheme is `config.nativeAppScheme`, as for every other native link of the web app:
 * `music24` in production, `music24rc` on staging, `music24local` locally.
 */
export function nativeCatalogConnectDeepLink(integrationType: string, scheme: string = config.nativeAppScheme): string {
  return `${scheme}://catalog/connect/${encodeURIComponent(integrationType)}`;
}

/**
 * True when a sign-in of this kind cannot run in the app's web view, so the page hands it to the
 * native connect. A Deezer login (`credentials`) is a plain form and stays on the page.
 */
export function signInNeedsNativeConnect(authKind: ArtistPortalAuthKind | null | undefined): boolean {
  return (
    authKind === ArtistPortalAuthKind.oauthRedirect ||
    authKind === ArtistPortalAuthKind.oauthCallback ||
    authKind === ArtistPortalAuthKind.capturedSession
  );
}

/** Sends the web view to a link of the app's own scheme. Tests pass their own function. */
export function openNativeLink(url: string): void {
  window.location.assign(url);
}
